import React from 'react';
import { Bell } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useNotificationStore } from '../../stores/notificationStore';
import { useAuth } from '../../contexts/AuthContext';

export default function NotificationBell() {
  const { unreadCount } = useNotificationStore();
  const { user } = useAuth();

  if (!user) return null;

  return (
    <Link
      to="/notifications"
      className="relative p-2 text-gray-600 hover:text-gray-900 focus:outline-none"
    >
      <Bell className="h-5 w-5" />
      {unreadCount > 0 && (
        <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white transform translate-x-1/2 -translate-y-1/2 bg-red-500 rounded-full">
          {unreadCount}
        </span>
      )}
    </Link>
  );
}